// Centralized study-related constants
// Status SSOT: @/types/studyStatus.type — re-exported here for page-local imports.

export {
  STUDY_STATUSES,
  STUDY_STATUS_VALUES,
  type StudyStatus,
  normalizeStudyStatus,
  isStudyStatus,
  isAnyStudyStatus,
  isAssignableStudyStatus,
} from "@/types/studyStatus.type";

export {
  SITE_STATUS as SITE_STATUSES,
  SITE_STATUS_VALUES,
  type SiteStatus,
} from "@/types/siteStatus.type";

// Study phase constants - use this format throughout the application
export const STUDY_PHASES = {
  PHASE_I: "Phase I",
  PHASE_II: "Phase II",
  PHASE_III: "Phase III",
  PHASE_IV: "Phase IV",
} as const;

// Array of all study phases for validation and iteration
export const STUDY_PHASE_VALUES = Object.values(STUDY_PHASES);

// Type definition for study phases
export type StudyPhase = (typeof STUDY_PHASES)[keyof typeof STUDY_PHASES];

// API phase mapping - for converting between display format (full) and API format (short)
export const DISPLAY_TO_API_PHASE_MAPPING = {
  [STUDY_PHASES.PHASE_I]: "I",
  [STUDY_PHASES.PHASE_II]: "II",
  [STUDY_PHASES.PHASE_III]: "III",
  [STUDY_PHASES.PHASE_IV]: "IV",
} as const;

// API to display phase mapping
export const API_TO_DISPLAY_PHASE_MAPPING = {
  I: STUDY_PHASES.PHASE_I,
  II: STUDY_PHASES.PHASE_II,
  III: STUDY_PHASES.PHASE_III,
  IV: STUDY_PHASES.PHASE_IV,
} as const;

// Helper function to convert display phase to API phase
export const convertDisplayPhaseToApi = (
  displayPhase: StudyPhase,
): "I" | "II" | "III" | "IV" => {
  return DISPLAY_TO_API_PHASE_MAPPING[displayPhase];
};

// Helper function to convert API phase to display phase
export const convertApiPhaseToDisplay = (
  apiPhase: keyof typeof API_TO_DISPLAY_PHASE_MAPPING,
): StudyPhase => {
  return API_TO_DISPLAY_PHASE_MAPPING[apiPhase];
};
